import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  CloseRounded as CloseRoundedIcon
} from "@mui/icons-material";
import TableComponent from "./TableComponent";

const ModalSensorFilter = ({ value, items, isOpen, onClose, onChange }) => {
  const handleReset = () => {
    onChange([]);
    onClose();
  };

  const handleChangeValue = React.useCallback((itemId) => {
    const idx = value.indexOf(itemId);
    if (idx > -1) {
      const next = [...value];
      next.splice(idx, 1);
      onChange(next);
    } else {
      onChange([...value, itemId]);
    }
  }, [value, onChange]);

  const handleChangeMultiple = React.useCallback((itemIds, shouldSelect) => {
    if (shouldSelect) {
      const set = new Set(value);
      itemIds.forEach(id => set.add(id));
      onChange([...set]);
    } else {
      const removeSet = new Set(itemIds);
      onChange(value.filter(id => !removeSet.has(id)));
    }
  }, [value, onChange]);

  if (!isOpen) return null;

  return (
    <Dialog
      open={true}
      maxWidth="xl"
      fullWidth
      onClose={onClose}
      sx={{
        "& .MuiDialog-container": { alignItems: "flex-start", pt: "5vh" },
        "& .MuiBackdrop-root": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 4.0002L3.06838 5.97741C3.02754 5.99102 3 6.02923 3 6.07227V20.8615C3 20.9297 3.06687 20.9779 3.13162 20.9563L9 19.0002V4.0002ZM9 4.0002L15 6.0002M15 6.0002L20.8684 4.04407C20.9331 4.02249 21 4.07068 21 4.13894V11.0002M15 6.0002V9.0002" stroke="#4F39F6" strokeWidth="2"/>
            <path d="M18.8853 18.8853L23 23M20.0667 16.0333C20.0667 18.2609 18.2609 20.0667 16.0333 20.0667C13.8058 20.0667 12 18.2609 12 16.0333C12 13.8058 13.8058 12 16.0333 12C18.2609 12 20.0667 13.8058 20.0667 16.0333Z" stroke="#4F39F6" strokeWidth="2"/>
          </svg>
          Выбор устройства
        </Box>
        <IconButton onClick={onClose}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <TableComponent
          items={items}
          selected={value}
          onChangeSelected={handleChangeValue}
          onChangeMultiple={handleChangeMultiple}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleReset} sx={{ color: "#E85949", borderColor: "#E85949", "&:hover": { borderColor: "#E85949", backgroundColor: "rgba(232,89,73,0.08)" } }}>
          Сбросить
        </Button>
        <Button variant="contained" onClick={onClose}>
          Применить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ModalSensorFilter);
